import { baseApi } from '@/shared/api'
import type { CatalogGlobalList, CatalogGlobalQuery } from '../model/types'

export const catalogSearchApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    /**
     * Глобальный поиск по всей номенклатуре. Поиск, сортировка, страница и итоги — на сервере
     * (правило 11); параметры уходят как есть, их имена — имена ручки. Модификатор контекста
     * не добавляется: `?client=` ручка отвергает `400`.
     */
    getCatalogGlobal: build.query<CatalogGlobalList, CatalogGlobalQuery>({
      query: (params) => ({ url: '/catalog/products/global', params }),
      providesTags: [{ type: 'CatalogSearch', id: 'GLOBAL' }],
    }),
  }),
})

export const { useGetCatalogGlobalQuery } = catalogSearchApi
